import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function NavimumbaiToKolhapurCab() {



    const cardData = {





keyword: "Navi Mumbai to Kolhapur Cab",

headingDescription: "Shreesha Tours & Travels offers reliable and comfortable Navi Mumbai to Kolhapur Cab Service for family vacations, business travel, pilgrimage tours, corporate travel, one-way taxi booking, round trips, and outstation journeys. We provide chauffeur-driven Sedan, SUV, Ertiga, Kia Carens, Innova, Innova Crysta, Tempo Traveller, and premium vehicles for a safe and enjoyable journey. With professional drivers, clean vehicles, transparent pricing, doorstep pickup, flexible travel plans, and 24/7 customer support, we ensure a smooth and hassle-free travel experience from Navi Mumbai to Kolhapur.",

topPlaces: [
  {
    title: "Mahalaxmi Temple Kolhapur",
    description: "Mahalaxmi Temple, also known as Ambabai Temple, is one of Maharashtra's most sacred Shakti Peethas and attracts lakhs of devotees throughout the year. The temple is renowned for its beautiful stone architecture, spiritual atmosphere, traditional festivals, and daily religious rituals. Visitors also explore the nearby local markets, authentic Kolhapuri food, and cultural heritage surrounding the temple, making it the city's most important pilgrimage and tourist destination."
  },
  {
    title: "Panhala Fort",
    description: "Panhala Fort is one of the largest and most historically significant forts in Maharashtra, closely associated with Chhatrapati Shivaji Maharaj. The fort offers magnificent views of the Sahyadri hills, ancient gateways, hidden tunnels, monuments, and historical structures. It is a favorite destination for history enthusiasts, photographers, families, and travelers looking to experience Maratha heritage."
  },
  {
    title: "Rankala Lake",
    description: "Rankala Lake is one of Kolhapur's most popular recreational attractions, known for its peaceful waterfront, evening sunset views, boating activities, horse rides, and local street food. Families and tourists enjoy relaxing walks along the lakeside while experiencing the pleasant atmosphere and beautiful city views throughout the year."
  },
  {
    title: "Jyotiba Temple",
    description: "Located on a scenic hill near Kolhapur, Jyotiba Temple is an important pilgrimage destination dedicated to Lord Jyotiba. The temple is famous for its annual fairs, vibrant religious celebrations, panoramic hilltop views, and peaceful surroundings. Thousands of devotees visit throughout the year, especially during the grand Chaitra festival."
  },
  {
    title: "New Palace Museum",
    description: "The New Palace Museum showcases the royal heritage of Kolhapur with impressive architecture, royal artifacts, weapons, paintings, costumes, vintage collections, and historical exhibits. Visitors can learn about the rich legacy of the Kolhapur royal family while exploring one of the city's finest heritage attractions."
  },
  {
    title: "Dajipur Wildlife Sanctuary",
    description: "Dajipur Wildlife Sanctuary, also known as Radhanagari Wildlife Sanctuary, is surrounded by dense forests and is home to Indian bison, deer, leopards, and numerous bird species. Nature lovers enjoy wildlife safaris, photography, trekking, and scenic drives through the lush Western Ghats landscape."
  },
  {
    title: "Radhanagari Dam",
    description: "Radhanagari Dam is a picturesque destination surrounded by hills, forests, and beautiful backwaters. During the monsoon season, the overflowing dam creates spectacular views that attract photographers, families, and nature lovers. It is an ideal place for a peaceful day trip from Kolhapur."
  },
  {
    title: "Vishalgad Fort",
    description: "Vishalgad Fort is a historic Maratha fort known for its strategic importance, ancient ruins, scenic mountain surroundings, and breathtaking viewpoints. The fort attracts history lovers, trekking enthusiasts, and travelers interested in exploring Maharashtra's glorious past while enjoying panoramic Sahyadri landscapes."
  },
  {
    title: "Amba Ghat",
    description: "Amba Ghat is one of the most scenic mountain passes in western Maharashtra, offering winding roads, lush greenery, waterfalls during the monsoon, mist-covered hills, and breathtaking viewpoints. It is a favorite destination for long drives, bike rides, nature photography, and weekend road trips."
  },
  {
    title: "Gaganbawda",
    description: "Gaganbawda is a beautiful hill destination near Kolhapur known for its cool climate, scenic valleys, historic fort, waterfalls, dense forests, and spectacular viewpoints overlooking the Konkan region. It is a perfect destination for families, couples, photographers, and travelers looking to experience the natural beauty of the Western Ghats."
  }
],


"services": [
  {
    "name": "Mumbai to Kolhapur Cab",
    "description": "Book Mumbai to Kolhapur Cab for safe, comfortable, and affordable outstation travel with experienced chauffeurs and well-maintained AC vehicles. Choose from Hyundai Aura, Swift Dzire, Ertiga, Innova, Innova Crysta, Kia Carens, Sedan, SUV, and luxury cabs for one-way, round-trip, family, corporate, and business travel."
  },
  {
    "name": "Mumbai Airport to Kolhapur Cab",
    "description": "Reserve Mumbai Airport to Kolhapur Cab for direct airport pickup with flight tracking, luggage assistance, experienced chauffeurs, and comfortable AC vehicles."
  },
  {
    "name": "Mumbai Kolhapur Cab Service",
    "description": "Choose Mumbai Kolhapur Cab Service for reliable one-way and round-trip travel with professional drivers, transparent pricing, and premium comfort."
  },
  {
    "name": "Mumbai to Kolhapur Car Rental",
    "description": "Book Mumbai to Kolhapur Car Rental with driver for comfortable long-distance travel, family trips, business visits, and flexible travel schedules."
  },
  {
    "name": "Navi Mumbai to Kolhapur Cab",
    "description": "Reserve Navi Mumbai to Kolhapur Cab for dependable intercity travel with experienced chauffeurs, clean AC vehicles, and affordable pricing."
  },
  {
    "name": "Navi Mumbai to Kolhapur Taxi",
    "description": "Choose Navi Mumbai to Kolhapur Taxi for safe and convenient travel with verified drivers, comfortable seating, and punctual pickup services."
  },
  {
    "name": "Navi Mumbai to Kolhapur Cab Service",
    "description": "Book Navi Mumbai to Kolhapur Cab Service for hassle-free transportation with professional chauffeurs, premium vehicles, and transparent fares."
  },
  {
    "name": "Taxi from Navi Mumbai to Kolhapur",
    "description": "Hire Taxi from Navi Mumbai to Kolhapur for comfortable long-distance travel with reliable drivers, spacious vehicles, and smooth journeys."
  },
  {
    "name": "Cab from Navi Mumbai to Kolhapur",
    "description": "Book Cab from Navi Mumbai to Kolhapur for one-way and round-trip travel with experienced chauffeurs and well-maintained AC vehicles."
  },
  {
    "name": "Book Cab Navi Mumbai to Kolhapur",
    "description": "Reserve Book Cab Navi Mumbai to Kolhapur online with instant confirmation, secure booking, flexible pickup timings, and multiple vehicle options."
  },
  {
    "name": "Online Cab Booking Navi Mumbai to Kolhapur",
    "description": "Choose Online Cab Booking Navi Mumbai to Kolhapur for quick reservations, transparent pricing, professional chauffeurs, and 24x7 support."
  },
  {
    "name": "Best Cab Navi Mumbai to Kolhapur",
    "description": "Book the Best Cab Navi Mumbai to Kolhapur for premium travel with sanitized vehicles, courteous chauffeurs, and exceptional customer service."
  },
  {
    "name": "Cheapest Cab Navi Mumbai to Kolhapur",
    "description": "Reserve the Cheapest Cab Navi Mumbai to Kolhapur with affordable fares, reliable drivers, and comfortable AC vehicles."
  },
  {
    "name": "Reliable Taxi Navi Mumbai to Kolhapur",
    "description": "Choose Reliable Taxi Navi Mumbai to Kolhapur for dependable transportation with experienced chauffeurs, clean vehicles, and timely service."
  },
  {
    "name": "One Way Cab Navi Mumbai to Kolhapur",
    "description": "Book One Way Cab Navi Mumbai to Kolhapur for economical drop taxi services without return charges and enjoy comfortable intercity travel."
  },
  {
    "name": "Round Trip Cab Navi Mumbai to Kolhapur",
    "description": "Reserve Round Trip Cab Navi Mumbai to Kolhapur for family vacations, business travel, and return journeys with flexible schedules."
  },
  {
    "name": "Outstation Cab Navi Mumbai to Kolhapur",
    "description": "Choose Outstation Cab Navi Mumbai to Kolhapur for long-distance travel with premium vehicles, experienced chauffeurs, and transparent pricing."
  },
  {
    "name": "Innova Cab Navi Mumbai to Kolhapur",
    "description": "Book Innova Cab Navi Mumbai to Kolhapur for spacious family travel with comfortable seating, extra luggage capacity, and smooth rides."
  },
  {
    "name": "Innova Crysta Cab Navi Mumbai to Kolhapur",
    "description": "Reserve Innova Crysta Cab Navi Mumbai to Kolhapur for luxury travel with premium interiors, spacious seating, and professional chauffeur service."
  },
  {
    "name": "Ertiga Cab Navi Mumbai to Kolhapur",
    "description": "Choose Ertiga Cab Navi Mumbai to Kolhapur for affordable family transportation with clean AC vehicles and experienced drivers."
  },
  {
    "name": "Swift Dzire Cab Navi Mumbai to Kolhapur",
    "description": "Book Swift Dzire Cab Navi Mumbai to Kolhapur for economical travel with comfortable sedan vehicles and reliable chauffeur-driven service."
  },
  {
    "name": "Kia Carens Cab Navi Mumbai to Kolhapur",
    "description": "Reserve Kia Carens Cab Navi Mumbai to Kolhapur for premium family travel with spacious interiors, modern features, and comfortable seating."
  },
  {
    "name": "Sedan Cab Navi Mumbai to Kolhapur",
    "description": "Choose Sedan Cab Navi Mumbai to Kolhapur for affordable intercity transportation with AC sedans, professional chauffeurs, and transparent fares."
  },
  {
    "name": "SUV Cab Navi Mumbai to Kolhapur",
    "description": "Book SUV Cab Navi Mumbai to Kolhapur for spacious long-distance travel with extra luggage capacity, premium comfort, and dependable service."
  }
],
"tableData": [
  ["Mumbai to Kolhapur Cab", "Mumbai Airport to Kolhapur Cab"],
  ["Mumbai Kolhapur Cab Service", "Mumbai to Kolhapur Car Rental"],
  ["Navi Mumbai to Kolhapur Cab", "Navi Mumbai to Kolhapur Taxi"],
  ["Navi Mumbai to Kolhapur Cab Service", "Taxi from Navi Mumbai to Kolhapur"],
  ["Cab from Navi Mumbai to Kolhapur", "Book Cab Navi Mumbai to Kolhapur"],
  ["Online Cab Booking Navi Mumbai to Kolhapur", "Best Cab Navi Mumbai to Kolhapur"],
  ["Cheapest Cab Navi Mumbai to Kolhapur", "Reliable Taxi Navi Mumbai to Kolhapur"],
  ["One Way Cab Navi Mumbai to Kolhapur", "Round Trip Cab Navi Mumbai to Kolhapur"],
  ["Outstation Cab Navi Mumbai to Kolhapur", "Innova Cab Navi Mumbai to Kolhapur"],
  ["Innova Crysta Cab Navi Mumbai to Kolhapur", "Ertiga Cab Navi Mumbai to Kolhapur"],
  ["Swift Dzire Cab Navi Mumbai to Kolhapur", "Kia Carens Cab Navi Mumbai to Kolhapur"],
  ["Sedan Cab Navi Mumbai to Kolhapur", "SUV Cab Navi Mumbai to Kolhapur"]
],




whychoose: [
  {
    WhyChooseheading: "Reliable Navi Mumbai to Kolhapur Cab Service",
    WhyChoosedescription: "Travel comfortably from Navi Mumbai to Kolhapur with Shreesha Travels. Our chauffeur-driven cab service is perfect for families, business travellers, pilgrims, students, and tourists looking for a safe and hassle-free journey."
  },
  {
    WhyChooseheading: "Door-to-Door Private Taxi Service",
    WhyChoosedescription: "Enjoy direct pickup from your home, office, hotel, or any location in Navi Mumbai with convenient drop-off anywhere in Kolhapur, eliminating the need for multiple transport options."
  },
  {
    WhyChooseheading: "Wide Range of Vehicles Available",
    WhyChoosedescription: "Choose from Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to your travel requirements and group size."
  },
  {
    WhyChooseheading: "Ideal for Family Trips, Business & Temple Visits",
    WhyChoosedescription: "Our Navi Mumbai to Kolhapur taxis are suitable for Mahalaxmi Temple darshan, corporate travel, family vacations, educational trips, hotel transfers, weddings, and weekend holidays."
  },
  {
    WhyChooseheading: "One-Way & Round Trip Cab Booking",
    WhyChoosedescription: "Book a one-way cab to Kolhapur or select a round-trip package with flexible return timing, sightseeing stops, and customized travel plans."
  },
  {
    WhyChooseheading: "Professional Drivers for Highway Travel",
    WhyChoosedescription: "Our experienced chauffeurs are familiar with the Mumbai–Bengaluru Highway and major Maharashtra routes, ensuring safe driving, punctual service, and a smooth long-distance journey."
  },
  {
    WhyChooseheading: "Comfortable & Well-Maintained Vehicles",
    WhyChoosedescription: "Every vehicle is regularly serviced, sanitized, air-conditioned, and inspected before every trip to provide a safe, clean, and relaxing travel experience."
  },
  {
    WhyChooseheading: "Book Navi Mumbai to Kolhapur Cab with Shreesha Travels",
    WhyChoosedescription: "Enjoy transparent pricing, instant booking confirmation, professional chauffeur service, and dependable transportation for your Navi Mumbai to Kolhapur journey."
  }
]

};

const faqData = [
  {
    question: "Can I book a one-way cab from Navi Mumbai to Kolhapur?",
    answer: "Yes, one-way taxi services are available for comfortable and direct travel from Navi Mumbai to Kolhapur."
  },
  {
    question: "Do you provide round-trip taxi services to Kolhapur?",
    answer: "Yes, round-trip cab packages are available with flexible return schedules and customized travel plans."
  },
  {
    question: "Which vehicles are available for Navi Mumbai to Kolhapur travel?",
    answer: "We provide Sedan Cars, Swift Dzire, Toyota Etios, Ertiga, Kia Carens, Innova, Innova Crysta, SUVs, Tempo Travellers, Mini Buses, and premium vehicles."
  },
  {
    question: "Can I visit Mahalaxmi Temple during my trip?",
    answer: "Yes, our cab service is ideal for Mahalaxmi Temple darshan and other religious or sightseeing destinations in and around Kolhapur."
  },
  {
    question: "Is the cab service suitable for family travel?",
    answer: "Yes, our spacious and comfortable vehicles are ideal for families, senior citizens, children, and group travellers."
  },
  {
    question: "Can I customize my travel itinerary?",
    answer: "Yes, you can include multiple stops, sightseeing locations, hotel pickups, or nearby destinations based on your travel requirements."
  },
  {
    question: "Are early morning and overnight departures available?",
    answer: "Yes, pickups can be scheduled according to your preferred travel time, including early morning and overnight journeys."
  },
  {
    question: "How is the Navi Mumbai to Kolhapur cab fare calculated?",
    answer: "The fare depends on the selected vehicle, travel distance, trip type, toll charges, parking fees, and additional travel requirements."
  },
  {
    question: "Do you provide corporate cab services to Kolhapur?",
    answer: "Yes, our taxi service is suitable for business meetings, factory visits, conferences, and executive travel."
  },
  {
    question: "How can I book Navi Mumbai to Kolhapur Cab with Shreesha Travels?",
    answer: "Simply share your pickup location, destination, travel date, passenger count, and preferred vehicle to receive a customized quotation and instant booking confirmation."
  }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Nilesh Patil",
    feedback: "Our Navi Mumbai to Kolhapur journey was comfortable from start to finish. The driver was courteous, the vehicle was spotless, and the trip was completed on schedule.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sneha Kulkarni",
    feedback: "We travelled to Kolhapur with our family and had an excellent experience. The cab was spacious, well-maintained, and the chauffeur made the entire journey pleasant and safe.",
    rating: 5
  }
];



    const Images = [
        { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
        { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
        { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
        { place: "/images/keyword/5.jpg", text: "Mumbai to Nashik Cab", link: "Mumbai-to-Nashik-Cab" },
        { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
        { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
        { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
        { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
        { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
        { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
        { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
        { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
        { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
        { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
        { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
        { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
        { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
        { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
        { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
        { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
        { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
        { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
        { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
        { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
    ];








const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Navi Mumbai to Kolhapur Cab",
  "image": "https://www.shreeshatravels.com/assets/images/navi-mumbai-to-kolhapur-cab.webp",
  "description":
    "Book Navi Mumbai to Kolhapur Cab with Shreesha Tours & Travels for comfortable and reliable outstation taxi services. We provide Sedan, Ertiga, SUV, Innova, and Innova Crysta cabs available 24x7 for family trips, business travel, religious tours, one-way, round-trip, and long-distance journeys from Navi Mumbai to Kolhapur with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Shreesha Tours & Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shreeshatravels.com/navi-mumbai-to-kolhapur-cab"
  }
};





    return (
        <div>

<Helmet>
  <title>Navi Mumbai to Kolhapur Cab | Outstation Taxi Service | +91 8355835813</title>

  <meta
    name="description"
    content="Book Navi Mumbai to Kolhapur Cab with Shreesha Travels for safe and comfortable outstation taxi services. Hire Sedan, Ertiga, SUV, Innova, and Innova Crysta for one-way trips, round trips, family travel, business journeys, and 24x7 cab booking from Navi Mumbai to Kolhapur."
  />

  <meta
    name="keywords"
    content="Mumbai to Kolhapur Cab, Mumbai Airport to Kolhapur Cab, Mumbai Kolhapur Cab Service, Mumbai to Kolhapur Car Rental, Navi Mumbai to Kolhapur Cab, Navi Mumbai to Kolhapur Taxi, Navi Mumbai to Kolhapur Cab Service, Taxi from Navi Mumbai to Kolhapur, Kolhapur Tour Cab, One Way Cab Navi Mumbai to Kolhapur, Round Trip Taxi Navi Mumbai to Kolhapur"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>


















            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/95.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Shreesha Tours & Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Shreesha Tours & Travels</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shreesha Tours & Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918355835813 " className="pc-call">+91 8355835813 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919930929439 " className="pc-call">+91 9930929439 </a>
                                        </div>
                                        <div className="pc-list">
                                            <a href="tel:+919022432779 " className="pc-call">+91 9022432779 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/91919930929439 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918355835813 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@shreeshatravels.com" className="pc-email">
                                            booking@shreeshatravels.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Shreesha Tours & Travels</strong><br />
                                            Office 125, Saishraddha CHS,
                                            Plot No 47, Near Koparkhairane Police Station,
                                            Sector 5, Sector 4,Ghansoli, Navi Mumbai,
                                            Maharashtra, India- 400701




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default NavimumbaiToKolhapurCab;